export default "__VITE_ASSET__DBRz3iPK__"